import {
  Component,
  inject,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import {
  MatPaginatorModule,
  MatPaginator,
  PageEvent,
} from '@angular/material/paginator';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { CommonModule, Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlertService } from '../../core/services/alert/alert.service';
import { Orders } from '../../core/interfaces/orders';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalStorageService } from '../../core/services/localStorage/local-storage.service';
import { AccountsService } from '../../core/services/accounts/accounts.service';
import { UsersService } from '../../core/services/users/users.service';
import { BrandService } from '../../core/services/brand/brand.service';
import { Subscription } from 'rxjs';

import { Title } from '@angular/platform-browser';
import { DataService } from '../../core/services/orders/data.service';
import { FormatDateTimePipe } from '../../core/pipe/custom-pipes';
import { BadgeColorPipe } from '../../core/pipe/badge-color.pipe';
import { BadgeVehiclePipe } from '../../core/pipe/badge-vehicle.pipe';
import { BadgeDeliveryPipe } from '../../core/pipe/badge-delivery.pipe';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';
import { FormAddCampaignComponent } from './form-add-campaign/form-add-campaign.component';
import { CampaignsService } from '../../core/services/campaigns/campaigns.service';
import { FormAddOrderComponent } from './form-add-order/form-add-order.component';
import { FormAddStockComponent } from './form-add-stock/form-add-stock.component';
import { SharedFilterComponent } from '../shared/shared-filter/shared-filter.component';
import { StocksService } from '../../core/services/stocks/stocks.service';
import Swal from 'sweetalert2';

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
}
@Component({
  selector: 'app-campaigns',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatTooltipModule,
    FormsModule,
    RouterModule,
    FormAddCampaignComponent,
    FormAddOrderComponent,
    FormAddStockComponent,
    FormatDateTimePipe,
    SharedFilterComponent,
    BadgeColorPipe,
    BadgeVehiclePipe,
    BadgeDeliveryPipe,
  ],
  templateUrl: './campaigns.component.html',
  styleUrl: './campaigns.component.css'
})
export class campaignsComponent implements OnDestroy {
  
  private route = inject(ActivatedRoute);
  private queryParamsSubscription?: Subscription;

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(SharedFilterComponent) sharedFilterComponent!: SharedFilterComponent;

  isEditMode = false;
  showForm = false;
  showFormOrders = false;
  showFormStock = false;
  aux_showForm = false;
  pageNumber: number = 1;
  pageSize: number = 100;

  sortColumn = 'updated_at';
  sortDirection = 'desc';

  stock_reference?: any;
  campaign_reference?: any;

  campaignData?: any;
  campaignPreData?: any;

  stockData?: any;
  stockPreData?: any;

  typeOrders: string = '';

  dataSource = new MatTableDataSource<Orders>();
  dataSourceStocks = new MatTableDataSource<any>();

  title = 'campaigns';

  searchParams: any = {};
  accountType: string | null = null;

  ladata: any = [];
  cargaladata: any = [];

  stage_type = '';

  tab = 'general';

  displayedColumns: string[] = [];
  displayedColumnsStock: string[] = [];

  campaignTable: boolean = false;

  currentStep: number = 1; // 1: Marcas, 2: Modelos, 3: Stock , 4: Campañas
  selectedBrand: any = null;
  selectedModel: any = null;
  selectedStock: any = null;
  breadcrumbs: Array<{ label: string, step: number }> = [];
  campaignsDataLoaded: boolean = false;
  isViewingAllStocks: boolean = false;
  isViewingExpanded: boolean = false;
  expandedPageNumber: number = 1;
  expandedPageSize: number = 25;
  expandedSortColumn: string = 'stage_updated_at';
  expandedSortDirection: string = 'asc';
  expandedSearchParams: any = {};

  // Información de unidades y vehículo de la primera campaña
  campaignUnitsInfo: any = {
    virtual_available_units: 0,
    available_units: 0,
    units: 0,
    name: '',
    vehicle_brand: '',
    vehicle_models: '',
    vehicle_model_year: '',
    type: '',
    vehicle: '',
    vehicle_status: '',
    colour: '',
    supplier_name: '',
    vendor_name: '',
    campaign_stock_vehicle_registered: '',
    campaign_stock_warning_label: null,
    breakdown: {
      total_units: 0,
      signed_contracts: 0,
      estimated_in_risk: 0
    }
  };


  brandsList: any[] = [];
  brandsListUsed: any[] = [];

  modelsListRegistered: any[] = [];
  modelsListNotRegistered: any[] = [];

  selectedBrandReference: string = '';

  filterType: string = 'campaigns';

  routesMap: { [key: string]: string } = {

    'campaigns/draft': 'draft',
    'campaigns/enabled': 'enabled',
    'campaigns/under-review': 'under_review',
    'campaigns/paused': 'paused',
    'campaigns/finished': 'finished',
    'campaigns/cancelled': 'cancelled',
    'campaigns/registering': 'registering',
    'campaigns/all': 'all',
    'campaigns': 'all',
  };

  sortMap: { [key: string]: string } = {
    vehicle: 'vehicle',
    vendor_name: 'vendor_name',
    campaign_reference: 'campaign_reference',
    name: 'name',
    stage: 'stage',
  };

  vehicle_status: string = 'new';
  vehicle_brand_reference_id: string = '';
  vehicle_model_reference_id: string = '';
  vehicle_registered: string = '';

  constructor(
    private alertService: AlertService,
    private campaignsService: CampaignsService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private accountService: AccountsService,
    private userService: UsersService,
    private brandService: BrandService,
    private titleService: Title,
    private dataService: DataService,
    private stocksService: StocksService,
    private authStateService: AuthStateService,
    private router: Router,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.displayedColumns = this.authStateService.getCampaignColumns();
    this.displayedColumnsStock = this.authStateService.getStocksColumns();
  }

  ngOnInit() {
    this.detectReference(),
      this.getAccountTypeFromLocalStorage();
    this.alertService.loading('swal_messages.please_wait');
    this.sortColumn = 'updated_at';
    this.sortDirection = 'desc';
    this.fetchInitialData();
    if (this.paginator) {
      this.paginator.pageSizeOptions = [25, 50, 100];
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = this.pageNumber - 1;
      this.paginator.length = 0;
    }

    // Suscribirse a cambios en query params para detectar navegación del navegador
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      // Siempre procesar, incluso si no hay step (será step 1 por defecto)
      this.loadStateFromUrl(params);
    });

    this.updateBreadcrumbs();
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  private loadStateFromUrl(params: any) {
    const step = parseInt(params['step']) || 1;
    const currentStep = this.currentStep;

    // Evitar ciclos infinitos - solo procesar si hay algo nuevo que procesar
    const campaignParam = params['campaign'] || null;
    const hasPendingCampaign = campaignParam && (!this.showForm || this.campaign_reference !== campaignParam);

    // If we're in expanded and the form is closing, stay in expanded
    if (this.isViewingExpanded && (step === 5 || params['expanded'] === 'true')) {
      this.currentStep = 5;
      this.updateBreadcrumbs();
      return;
    }

    if (step === currentStep && !params['stock'] && !hasPendingCampaign && !params['expanded']) {
      return;
    }

    this.currentStep = step;

    // Restore expanded state from URL
    if (step === 5 || params['expanded'] === 'true') {
      this.isViewingExpanded = true;
      this.currentStep = 5;
      this.updateBreadcrumbs();
      this.fetchExpandedData();
      return;
    }

    this.isViewingExpanded = false;

    // Restaurar estado según el step
    if (step === 1) {
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedStock = null;
      this.isViewingAllStocks = false;
      this.vehicle_brand_reference_id = '';
      this.vehicle_model_reference_id = '';
      this.vehicle_registered = '';
      this.vehicle_status = 'new';
      this.searchParams = {};
      this.filterType = 'stocks';

      // Limpiar filtros
      if (this.sharedFilterComponent) {
        this.sharedFilterComponent.setFilterForType('stocks', this.searchParams);
      }
    } else if (step === 2 && params['brand']) {
      // Si tenemos brand en la URL, intentar restaurar
      const brandRef = params['brand'];
      const vehicleStatus = params['vehicleStatus'] || 'new';
      this.vehicle_status = vehicleStatus;
      this.vehicle_brand_reference_id = brandRef;
      this.selectedModel = null;
      this.selectedStock = null;
      this.isViewingAllStocks = false;
      this.vehicle_model_reference_id = '';
      this.vehicle_registered = '';
      this.filterType = 'stocks';
    } else if (step === 3) {
      const isViewingAll = params['viewAll'] === 'true';
      this.isViewingAllStocks = isViewingAll;
      this.filterType = 'stocks';

      if (params['model']) {
        const modelRef = params['model'];
        const registered = params['registered'];
        const brandRef = params['brand'];
        const vehicleStatus = params['vehicleStatus'] || 'new';

        this.vehicle_model_reference_id = modelRef;
        this.vehicle_registered = registered;
        this.vehicle_brand_reference_id = brandRef;
        this.vehicle_status = vehicleStatus;
      } else if (isViewingAll) {
        // Si estamos viendo todos y no hay model, limpiar selecciones
        this.selectedBrand = null;
        this.selectedModel = null;
        this.vehicle_model_reference_id = '';
        this.vehicle_brand_reference_id = '';
        this.vehicle_registered = '';
      }
      this.selectedStock = null;
    } else if (step === 4 && params['stock']) {
      const stockRef = params['stock'];
      const modelRef = params['model'];
      const registered = params['registered'];
      const brandRef = params['brand'];
      const vehicleStatus = params['vehicleStatus'] || 'new';
      let campaignRef = params['campaign'];

      // Brokers no pueden editar campañas: limpiar el param de la URL
      if (campaignRef && this.accountType === 'broker') {
        campaignRef = null;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { campaign: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }

      this.vehicle_model_reference_id = modelRef || '';
      this.vehicle_registered = registered || '';
      this.vehicle_brand_reference_id = brandRef || '';
      this.vehicle_status = vehicleStatus;
      this.isViewingAllStocks = false;
      this.filterType = 'campaigns';

      // Si no hay brand ni model, limpiar las selecciones
      if (!brandRef && !modelRef) {
        this.selectedBrand = null;
        this.selectedModel = null;
      }

      // Cargar el stock y sus campañas si no está ya cargado
      if (!this.selectedStock || this.selectedStock.reference !== stockRef) {
        this.loadStockAndCampaigns(stockRef, campaignRef);
        return; // No actualizar breadcrumbs aún, lo hará loadStockAndCampaigns
      }

      // Si el stock ya está cargado pero hay campaign en la URL, abrirla
      if (campaignRef && (!this.showForm || this.campaign_reference !== campaignRef)) {
        this.getCampaign(campaignRef);
      }
    }

    this.updateBreadcrumbs();
  }

  private loadStockAndCampaigns(stockRef: string, campaignRef?: string): void {
    this.alertService.loading('swal_messages.please_wait');

    this.stocksService.searchStock(stockRef).subscribe({
      next: (data) => {
        this.selectedStock = data.data;

        const campaignParams: any = {};
        campaignParams['campaign_stock_reference_id[in][]'] = [stockRef];
        this.searchParams = campaignParams;

        this.campaignPreData = {
          campaign_stock_reference: stockRef
        };

        this.updateBreadcrumbs();

        this.filterChanged(campaignParams).then(() => {
          this.campaignsDataLoaded = true;
          this.alertService.close();

          // Si hay campaign en la URL, abrirla después de cargar el stock (solo suppliers)
          if (campaignRef && this.accountType !== 'broker') {
            this.getCampaign(campaignRef);
          }
        }).catch(() => {
          this.alertService.close();
        });
      },
      error: (error) => {
        console.error('Error loading stock:', error);
        this.alertService.error('swal_messages.stock_not_found');
        // Redireccionar al step 1 si el stock no existe
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { step: 1 },
          replaceUrl: true
        });
      }
    });
  }

  private updateUrl() {
    const queryParams: any = {
      step: this.currentStep
    };

    if (this.currentStep === 2 && this.vehicle_brand_reference_id) {
      queryParams['brand'] = this.vehicle_brand_reference_id;
      queryParams['vehicleStatus'] = this.vehicle_status;
    } else if (this.currentStep === 3) {
      if (this.isViewingAllStocks) {
        queryParams['viewAll'] = 'true';
      } else if (this.vehicle_model_reference_id) {
        queryParams['brand'] = this.vehicle_brand_reference_id;
        queryParams['vehicleStatus'] = this.vehicle_status;
        queryParams['model'] = this.vehicle_model_reference_id;
        queryParams['registered'] = this.vehicle_registered;
      }
    } else if (this.currentStep === 5 && this.isViewingExpanded) {
      queryParams['expanded'] = 'true';
    } else if (this.currentStep === 4 && this.selectedStock) {
      queryParams['stock'] = this.selectedStock.reference;
      
      // Solo incluir brand, model, etc. si existen (navegación normal)
      if (this.vehicle_brand_reference_id) {
        queryParams['brand'] = this.vehicle_brand_reference_id;
        queryParams['vehicleStatus'] = this.vehicle_status;
      }
      if (this.vehicle_model_reference_id) {
        queryParams['model'] = this.vehicle_model_reference_id;
      }
      if (this.vehicle_registered) {
        queryParams['registered'] = this.vehicle_registered;
      }
    }

    // Reemplazar completamente los query params en lugar de hacer merge
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: false
    });
  }

  private updateUrlWithCampaign(campaignRef: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { campaign: campaignRef },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private removeUrlCampaignParam() {
    const currentParams = { ...this.route.snapshot.queryParams };
    delete currentParams['campaign'];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
      replaceUrl: true
    });
  }

  private fetchInitialData() {
    Promise.all([
      this.fetchData2(),
      this.fetchData3(),
      this.fetchData5(),
      this.fetchBrandsData()
    ]).then(() => {
      this.ladata = this.cargaladata;
      this.ladata.flag = true;
      this.dataService.setLadata(this.ladata);
      this.showForm = this.aux_showForm;
      setTimeout(() => {
        this.alertService.close();
      }, 500);
    });
  }

  fetchBrandsData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.campaignsService.getCampaignStocksGrouped(this.typeOrders).subscribe({
        next: (response) => {
          if (response.data.new) {
            this.brandsList = Object.values(response.data.new).map((brand: any) => ({
              logo: brand.image,
              ...brand
            }));
          }
          if (response.data.used) {
            this.brandsListUsed = Object.values(response.data.used).map((brand: any) => ({
              logo: brand.image,
              ...brand

            }));
          }
          resolve();
        },
        error: (error) => {
          console.error('Error al cargar marcas:', error);
          this.alertService.error('Error al cargar las marcas');
          this.brandsList = [];
          this.brandsListUsed = [];
          reject(error);
        }
      });
    });
  }

  extractSvgPath(svgString: string): string {
    if (!svgString) return '';
    // Si ya es solo un path, devolverlo tal cual
    if (!svgString.includes('<')) {
      return svgString;
    }
    // Extraer el valor del atributo d del elemento path
    const match = svgString.match(/d="([^"]+)"/);
    return match ? match[1] : svgString;
  }

  sanitizeSvg(svg: string): SafeHtml {
    if (!svg) {
      return this.sanitizer.bypassSecurityTrustHtml('<svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor"><path d="M19.804 7.8c-.983 0-1.886.338-2.601.904a4.175 4.175 0 0 0-2.601-.904c-.983 0-1.887.338-2.602.904A4.173 4.173 0 0 0 9.398 7.8c-.983 0-1.886.338-2.602.904a4.195 4.195 0 1 0-2.601 7.487c.983 0 1.887-.338 2.601-.904.716.566 1.62.904 2.602.904.983 0 1.886-.338 2.6-.904.717.566 1.621.904 2.604.904a4.18 4.18 0 0 0 2.602-.904A4.195 4.195 0 1 0 19.805 7.8h-.001zM6.11 14.602a3.232 3.232 0 0 1-5.149-2.607A3.232 3.232 0 0 1 6.11 9.388a4.197 4.197 0 0 0 0 5.212l.001.002zm.687-.684a3.216 3.216 0 0 1-.634-1.923c0-.721.233-1.383.634-1.921.398.538.631 1.2.631 1.921a3.21 3.21 0 0 1-.633 1.922h.002zm4.514.684c-.537.395-1.2.627-1.917.627a3.212 3.212 0 0 1-1.913-.627 4.185 4.185 0 0 0 .003-5.213 3.215 3.215 0 0 1 1.913-.627c.718 0 1.38.232 1.917.627-.57.716-.909 1.62-.909 2.606a4.2 4.2 0 0 0 .908 2.607h-.002zm.688-.684a3.215 3.215 0 0 1-.633-1.922c0-.721.235-1.384.633-1.922.399.538.634 1.2.634 1.921a3.21 3.21 0 0 1-.634 1.922zm4.516.684c-.537.395-1.2.627-1.917.627a3.212 3.212 0 0 1-1.913-.627 4.191 4.191 0 0 0 0-5.213 3.215 3.215 0 0 1 1.914-.627c.717 0 1.38.232 1.917.627a4.168 4.168 0 0 0-.908 2.606 4.2 4.2 0 0 0 .907 2.607zm.687-.684a3.227 3.227 0 0 1-.632-1.922c0-.721.235-1.384.634-1.922.398.538.633 1.2.633 1.921a3.21 3.21 0 0 1-.634 1.922h-.001zm2.603 1.312c-.712 0-1.38-.24-1.915-.63a4.2 4.2 0 0 0 0-5.212 3.234 3.234 0 0 1 5.149 2.607 3.234 3.234 0 0 1-3.234 3.234z"></path></svg>');
    }
    return this.sanitizer.bypassSecurityTrustHtml("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"currentColor\">" + svg + "</svg>");
  }

  selectBrand(brand: any, vehicle_status: string = 'new') {
    this.selectedBrand = brand;
    this.vehicle_brand_reference_id = brand.reference;
    this.vehicle_status = vehicle_status;
    this.loadModelsForBrand(brand);
    this.goToStep(2);

  }

  loadModelsForBrand(brand: any) {
    this.modelsListRegistered = [];
    this.modelsListNotRegistered = [];
    if (brand.registered && brand.registered.models) {
      this.modelsListRegistered = Object.values(brand.registered.models).map((model: any) => ({
        vehicle_registered: '1',
        ...model
      }));
    }
    if (brand.not_registered && brand.not_registered.models) {
      this.modelsListNotRegistered = Object.values(brand.not_registered.models).map((model: any) => ({
        vehicle_registered: '0',
        ...model
      }));
    }
  }

  selectModel(model: any) {
    this.selectedModel = model;
    this.vehicle_model_reference_id = model.reference;
    this.vehicle_registered = model.vehicle_registered;
    this.isViewingAllStocks = false;
    this.goToStep(3);
  }

  goStocks(): void {
    this.searchParams['vehicle_model_reference_id[in][]'] = [this.vehicle_model_reference_id];
    this.searchParams['vehicle_brand_reference_id[in][]'] = [this.vehicle_brand_reference_id];
    this.searchParams['vehicle_registered[eq]'] = [this.vehicle_registered];
    this.searchParams['vehicle_status[eq]'] = this.vehicle_status;

    if (this.sharedFilterComponent) {
      this.sharedFilterComponent.setFilterForType('stocks', this.searchParams);
    }
    this.fetchDataStock();
  }

  goToAllCampaignsExpanded(): void {
    this.searchParams = {};
    this.expandedSearchParams = {};
    this.expandedPageNumber = 1;
    this.selectedBrand = null;
    this.selectedModel = null;
    this.selectedStock = null;
    this.isViewingAllStocks = false;
    this.isViewingExpanded = true;
    this.filterType = 'expanded';
    this.currentStep = 5;
    if (this.sharedFilterComponent) {
      this.sharedFilterComponent.setFilterForType('expanded', {});
    }
    this.updateBreadcrumbs();
    this.updateUrl();
    this.fetchExpandedData();
  }

  fetchExpandedData(): void {
    this.alertService.loading('swal_messages.please_wait');
    this.campaignsService.getCampaignsExpanded(
      this.expandedPageNumber,
      this.expandedPageSize,
      this.expandedSearchParams,
      this.expandedSortColumn,
      this.expandedSortDirection,
      this.typeOrders || 'enabled'
    ).subscribe({
      next: (data: any) => {
        this.dataSource.data = data.data || [];
        if (this.paginator && data.meta) {
          this.paginator.length = data.meta.total;
          this.paginator.pageSize = this.expandedPageSize;
          this.paginator.pageIndex = this.expandedPageNumber - 1;
        }
        this.alertService.close();
      },
      error: (error: any) => {
        this.alertService.close();
        this.alertService.error(error.error);
      },
    });
  }

  onExpandedPageChange(event: any): void {
    this.expandedPageNumber = event.pageIndex + 1;
    this.expandedPageSize = event.pageSize;
    this.fetchExpandedData();
  }

  onExpandedSort(column: string): void {
    if (this.expandedSortColumn === column) {
      this.expandedSortDirection = this.expandedSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.expandedSortColumn = column;
      this.expandedSortDirection = 'asc';
    }
    this.expandedPageNumber = 1;
    this.fetchExpandedData();
  }

  goToAllStocks(): void {
    // Limpiar filtros y resetear selecciones
    this.searchParams = {};
    this.selectedBrand = null;
    this.vehicle_brand_reference_id = '';
    this.selectedModel = null;
    this.vehicle_model_reference_id = '';
    this.selectedStock = null;
    this.vehicle_registered = '';
    this.vehicle_status = 'new';
    this.isViewingAllStocks = true;

    // Asegurar que los datos estén disponibles para los filtros
    /* this.ladata = this.cargaladata;
    this.ladata.flag = true;
    this.dataService.setLadata(this.ladata); */

    this.goToStep(3);
    // Cargar todos los stocks sin filtros
    /*  this.alertService.loading('swal_messages.please_wait');
     if (this.sharedFilterComponent) {
       this.sharedFilterComponent.setFilterForType('stocks', this.searchParams);
     }
     this.fetchDataStock().then(() => {
       this.alertService.close();
     }).catch(() => {
       this.alertService.close();
     }); */
  }

  goToStep(step: number): void {
    this.currentStep = step;
    if (step === 1) {
      this.selectedBrand = null;
      this.vehicle_brand_reference_id = '';
      this.selectedModel = null;
      this.vehicle_model_reference_id = '';
      this.selectedStock = null;
      this.filterType = 'brand';
      this.isViewingAllStocks = false;
      this.searchParams = {};
      this.dataSourceStocks.data = [];
      if (this.sharedFilterComponent) {
        this.sharedFilterComponent.setFilterForType(this.filterType, this.searchParams);
      }
    } else if (step === 2) {
      this.selectedModel = null;
      this.vehicle_model_reference_id = '';
      this.selectedStock = null;
      this.filterType = 'models';
      this.isViewingAllStocks = false;
      this.searchParams = {};
      this.dataSourceStocks.data = [];
      if (this.sharedFilterComponent) {
        this.sharedFilterComponent.setFilterForType(this.filterType, this.searchParams);
      }
    } else if (step === 3) {
      // Si no hay marca ni modelo seleccionados, activar vista de "todas las campañas"
      if (!this.selectedBrand && !this.selectedModel) {
        this.isViewingAllStocks = true;
        this.searchParams = {};
      } else if (this.isViewingAllStocks) {
        this.searchParams = {};
      } else {
        this.searchParams['vehicle_model_reference_id[in][]'] = [this.vehicle_model_reference_id];
        this.searchParams['vehicle_brand_reference_id[in][]'] = [this.vehicle_brand_reference_id];
        this.searchParams['vehicle_registered[eq]'] = [this.vehicle_registered];
        this.searchParams['vehicle_status[eq]'] = this.vehicle_status;
      }
  
      this.filterType = 'stocks';
      if (this.sharedFilterComponent) {
        this.sharedFilterComponent.setFilterForType(this.filterType, this.searchParams);
      }
     
      this.selectedStock = null;
     // this.fetchDataStock();
    } else if (step === 4) {
      this.filterType = 'campaigns';
    //  this.fetchData();
    }
    this.updateBreadcrumbs();
    this.updateUrl();
  }

  updateBreadcrumbs() {
    this.breadcrumbs = [];

    // Vista expanded (todas las campañas)
    if (this.currentStep === 5 && this.isViewingExpanded) {
      this.breadcrumbs.push({ label: this.translate.instant('campaigns.back'), step: 1 });
      this.breadcrumbs.push({ label: this.translate.instant('campaigns.all_campaigns'), step: 5 });
      return;
    }

    // Si estamos viendo todos los stocks (step 3 sin navegación previa)
    if (this.currentStep === 3 && this.isViewingAllStocks) {
      this.breadcrumbs.push({ label: this.translate.instant('campaigns.back'), step: 1 });
      this.breadcrumbs.push({ label: this.translate.instant('campaigns.all_stocks'), step: 3 });
      return;
    }

    // Si estamos en step 4 pero no tenemos marca ni modelo seleccionados, 
    // significa que venimos de "ver todas las campañas"
    if (this.currentStep === 4 && this.selectedStock && !this.selectedBrand && !this.selectedModel) {
      this.breadcrumbs.push({ label: this.translate.instant('campaigns.back'), step: 3 });
      this.breadcrumbs.push({ label: this.selectedStock.campaign_stock_reference, step: 4 });
      return;
    }

    if (this.currentStep >= 1) {
      this.breadcrumbs.push({ label: this.getStageTitle(), step: 1 });
    }

    if (this.currentStep >= 2 && this.selectedBrand) {
      const vehicleTypeSuffix = this.vehicle_status === 'new'
        ? ` (${this.translate.instant('badge-status_select-stage.new')})`
        : ` (${this.translate.instant('badge-status_select-stage.used')})`;
      this.breadcrumbs.push({ label: this.selectedBrand.name + vehicleTypeSuffix, step: 2 });
    }

    if (this.currentStep >= 3 && this.selectedModel) {
      const registrationStatus = this.vehicle_registered === '1'
        ? this.translate.instant('campaigns.registered')
        : this.translate.instant('campaigns.not_registered');
      this.breadcrumbs.push({ label: `${this.selectedModel.name} (${registrationStatus})`, step: 3 });
    }

    if (this.currentStep === 4 && this.selectedStock) {
      this.breadcrumbs.push({ label: this.selectedStock.campaign_stock_reference, step: 4 });
    }
  }

  shouldShowAddButton(): boolean {
    if (this.accountType === 'broker') {
      return false;
    }
    if (this.isViewingExpanded) {
      return false;
    }
    return this.accountType === 'supplier';
  }

  getAddButtonLabel(): string {
    if (this.currentStep != 4) {
      return this.translate.instant('campaigns.add_stock');
    } else {
      return this.translate.instant('campaigns.add_campaign');
    }
  }

  getStageTitle(): string {
    const stageTitleMap: { [key: string]: string } = {
      'draft': 'campaigns.draft_campaigns',
      'enabled': 'campaigns.enabled_campaigns',
      'under_review': 'campaigns.under_review_campaigns',
      'paused': 'campaigns.paused_campaigns',
      'finished': 'campaigns.finished_campaigns',
      'cancelled': 'campaigns.cancelled_campaigns',
      'registering': 'campaigns.registering_campaigns',
      'all': 'campaigns.all_campaigns'
    };
    const titleKey = stageTitleMap[this.typeOrders] || 'campaigns.campaigns';
    return this.translate.instant(titleKey);
  }

  getStepTitle(): string {
    switch (this.currentStep) {
      case 1:
        return this.getStageTitle();
      case 2:
        if (this.selectedBrand) {
          return `${this.getStageTitle()} ${this.translate.instant('campaigns.of')} ${this.selectedBrand.name}`;
        }
        return this.getStageTitle();
      case 3:
        if (this.selectedBrand && this.selectedModel) {
          const vehicleTypeText = this.vehicle_status === 'new'
            ? this.translate.instant('badge-status_select-stage.new')
            : this.translate.instant('badge-status_select-stage.used');
          const registrationStatus = this.vehicle_registered === '1'
            ? this.translate.instant('campaigns.registered')
            : this.translate.instant('campaigns.not_registered');
          return `${this.getStageTitle()} ${this.translate.instant('campaigns.of')} ${this.selectedBrand.name} ${this.selectedModel.name} (${vehicleTypeText} y ${registrationStatus})`;
        }
        return this.translate.instant('campaigns.campaign_stocks');
      case 4:
        if (this.selectedStock) {
          return `${this.translate.instant('campaigns.campaigns')} ${this.selectedStock.campaign_stock_reference || this.selectedStock.reference || ''}`;
        }
        return this.translate.instant('campaigns.campaigns');
      default:
        return this.translate.instant('campaigns.campaigns');
    }
  }

  onAddButtonClick() {
    if (this.currentStep !== 4) {
      this.stockPreData = {};

      if (this.vehicle_brand_reference_id) {
        this.stockPreData.vehicle_brand_id = this.vehicle_brand_reference_id;
      }

      if (this.vehicle_model_reference_id) {
        this.stockPreData.vehicle_model_id = this.vehicle_model_reference_id;
      }

      if (this.vehicle_status) {
        this.stockPreData.vehicle_status = this.vehicle_status;
      }

      if (this.vehicle_registered) {
        this.stockPreData.vehicle_registered = this.vehicle_registered;
      }

      this.isEditMode = false;
      this.showFormStock = true;
    } else {
      if (this.selectedStock) {
        this.addCampaingFromStock(this.selectedStock.reference);
      } else {
        this.campaignPreData = {};
        this.isEditMode = false;
        this.showForm = true;
      }
    }
  }




  private fetchNewData() {
    if (this.currentStep === 3) {
      // Paso 3: Recargar stocks
      Promise.all([this.fetchDataStock()]).then(() => {
        this.ladata = this.cargaladata;
        setTimeout(() => {
          this.alertService.close();
        }, 500);
      });
    } else {
      // Otros pasos: Recargar campañas
      Promise.all([this.fetchData()]).then(() => {
        this.ladata = this.cargaladata;
        setTimeout(() => {
          this.alertService.close();
        }, 500);
      });
    }
  }

  expandedRow: any = null;

  toggleRow(row: any): void {
    if (this.expandedRow === row) {} else {
      this.expandedRow = row;
    }
    
   
  }

  fetchData(): Promise<void> {
    this.searchParams = this.localStorageService.getItem('searchParamsCampaign') || {};
    return new Promise((resolve, reject) => {
      this.alertService.loading('swal_messages.please_wait');
      this.campaignsService
        .getCampaigns(
          this.pageNumber,
          this.pageSize,
          this.searchParams,
          this.sortColumn,
          this.sortDirection
        )
        .subscribe({
          next: (data) => {
            this.dataSource.data = data.data;
            this.cargaladata.flag = true;
            this.dataSource.sort = this.sort;

            // Actualizar información de unidades y vehículo de la primera campaña
            if (data.data && data.data.length > 0) {
              const firstCampaign: any = data.data[0];
              this.campaignUnitsInfo = {
                virtual_available_units: firstCampaign.virtual_available_units || 0,
                available_units: firstCampaign.available_units || 0,
                units: firstCampaign.units || 0,
                name: firstCampaign.name || '',
                vehicle_brand: firstCampaign.vehicle_brand || '',
                vehicle_models: firstCampaign.vehicle_models || '',
                vehicle_model_year: firstCampaign.vehicle_model_year || '',
                vehicle: firstCampaign.vehicle || '',
                vehicle_status: firstCampaign.vehicle_status || '',
                colour: firstCampaign.colour || '',
                type: firstCampaign.type || '',
                supplier_name: firstCampaign.supplier_name || '',
                vendor_name: firstCampaign.vendor_name || '',
                vehicle_registered: this.vehicle_registered || 0,
                campaign_stock_warning_label: this.selectedStock?.campaign_stock_warning_label || null,
                breakdown: firstCampaign.breakdown || {
                  total_units: firstCampaign.units || 0,
                  signed_contracts: (firstCampaign.units || 0) - (firstCampaign.available_units || 0),
                  estimated_in_risk: (firstCampaign.available_units || 0) - (firstCampaign.virtual_available_units || 0)
                }
              };
            }

            this.pageNumber = data.meta.current_page;
            if (!this.localStorageService.getItem('per_page')) {
              this.localStorageService.setItem('per_page', data.meta.per_page);
              this.pageSize = data.meta.per_page;
            } else {
              this.pageSize = Number(
                this.localStorageService.getItem('per_page')
              );
            }

            this.alertService.close();
            resolve();

          },
          error: (error) => {
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }

  fetchData2(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.accountService.getData().subscribe({
        next: (response: ApiResponse) => {
          if (!response || !response.data) {
            resolve(); // Termina la ejecución y resuelve la promesa si no hay datos

            return;
          }
          const data: AccountData[] = response.data;
          this.cargaladata.vendorData = data.filter(
            (item) => item.type === 'vendor'
          );
          this.cargaladata.brokerData = data.filter(
            (item) => item.type === 'broker'
          );
          this.cargaladata.supplierData = data.filter(
            (item) => item.type === 'supplier'
          );
          this.cargaladata.workshopData = data.filter(
            (item) => item.type === 'workshop'
          );
          this.cargaladata.dealershipData = data.filter(
            (item) => item.type === 'dealership'
          );
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
  fetchData3(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.brandService.getData().subscribe({
        next: (data) => {
          this.cargaladata.brands = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData5(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userService.getUserAgent().subscribe({
        next: (data) => {
          this.cargaladata.agentData = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchDataStock(): Promise<void> {
    if (Object.keys(this.searchParams).length === 0) {
      this.searchParams = JSON.parse(this.localStorageService.getItem('searchParamsStockCampaign') || '{}');
    }

    return new Promise((resolve, reject) => {
      this.stocksService
        .getStocksStage(
          this.pageNumber,
          this.pageSize,
          this.searchParams,
          this.sortColumn,
          this.sortDirection,
          this.typeOrders
        )
        .subscribe({
          next: (data) => {
            this.dataSourceStocks.data = data.data;
            this.dataSourceStocks.sort = this.sort;
            this.pageNumber = data.meta.current_page;

            if (this.paginator) {
              this.paginator.pageIndex = this.pageNumber - 1;
              this.paginator.length = data.meta.total;
            }

            this.cargaladata.campaignStock = data.data;
            resolve();
          },
          error: (error) => {
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }

  getCampaign(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');

    this.stock_reference = reference;
    this.campaignsService.searchCampaign(this.stock_reference).subscribe({
      next: (data) => {
        this.campaignData = data.data;
        this.aux_showForm = true;
        this.showForm = true;
        this.isEditMode = true;
        this.campaign_reference = reference;
        this.updateUrlWithCampaign(reference);
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error('swal_messages.campaign_not_found');
      },
    });
  }

  duplicateCampaign(reference: string): void {
    this.alertService
      .confirmation2(
        'swal_messages.duplicate_campaign',
        'swal_messages.duplicate_campaign_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');


          this.campaign_reference = reference;
          this.campaignsService.duplicateCampaign(this.campaign_reference).subscribe({
            next: (data) => {
              this.campaignData = data.data;
              this.campaign_reference = this.campaignData.reference;
              this.aux_showForm = true;
              this.showForm = true;
              this.alertService.close();
            },
            error: (error) => {
              this.alertService.error('swal_messages.campaign_not_found');
            },
          });

        } else {
        }
      });


  }

  showFormOrder(campaign: any): void {
    this.campaignData = campaign;
    this.showFormOrders = true;
  }

  goOrders(reference: string): void {
    this.searchParams['campaign_reference_id[eq]'] = reference;
    if (this.sharedFilterComponent) {
      this.sharedFilterComponent.setFilterForType('orders', this.searchParams);
    }

    this.router.navigate(['/orders']);
  }

  deleteCampaign(reference: string): void {
    this.alertService
      .confirmation(
        'swal_messages.warning_confirm',
        'swal_messages.delete_campaign',
        'swal_messages.confirm'
      )
      .then((result) => {
        if (result.isConfirmed) {
          const currentPage = this.paginator ? this.paginator.pageIndex + 1 : 1;
          this.campaign_reference = reference;
          this.campaignsService.deleteCampaign(this.campaign_reference).subscribe(
            () => {
              this.alertService.successOk('swal_messages.complete_success');
              this.refreshCampaignsData();
            },
            (error) => {
              this.alertService.error('swal_messages.order_delete_error');
              console.error('Error al eliminar el cliente:', error);
            }
          );
          this.alertService.close();
        }
      });
  }

  getStock(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');

    this.stock_reference = reference;
    this.stocksService.searchStock(reference).subscribe({
      next: (data) => {
        this.stockData = data.data;
        this.showFormStock = true;
        console.log('Editar stock:', data);
        this.alertService.close();
        console.log('Función de editar stock en desarrollo');
      },
      error: (error) => {
        this.alertService.error('swal_messages.stock_not_found');
      },
    });
  }

  deleteStock(reference: string): void {
    this.alertService
      .confirmation(
        'swal_messages.warning_confirm',
        'swal_messages.delete_stock',
        'swal_messages.confirm'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.stocksService.deleteStock(reference).subscribe(
            () => {
              this.alertService.successOk('swal_messages.complete_success');
              this.fetchDataStock();;
            },
            (error) => {
              this.alertService.error('swal_messages.stock_delete_error');
              console.error('Error al eliminar el stock:', error);
            }
          );
          this.alertService.close();
        }
      });
  }

  addCampaingFromStock(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');
    let formData = { "campaign_stock_id": reference };
    this.stocksService.addCampaignFromStock(formData).subscribe({
      next: (data) => {
        this.alertService.close();
        this.campaignData = data.data;
        this.campaign_reference = data.data.reference;

        this.fetchData().then(() => {
          this.campaignsDataLoaded = true;
        });

        this.isEditMode = true;
        this.showForm = true;
        this.updateUrlWithCampaign(data.data.reference);
      },
      error: (error) => {
        this.alertService.error(error.error);
      }
    });
  }

  goCampaignsFromStock(stock: any): void {
    this.selectedStock = stock;

    this.currentStep = 4;
    this.filterType = 'campaigns';
    this.isViewingAllStocks = false;

    const campaignParams: any = {};
    campaignParams['campaign_stock_reference_id[in][]'] = [stock.reference];
    this.searchParams = campaignParams;

    this.campaignPreData = {
      campaign_stock_reference: stock.reference
    };

    this.updateBreadcrumbs();
    this.updateUrl();

    this.alertService.loading('swal_messages.please_wait');
     this.filterChanged(campaignParams).then(() => {
      this.campaignsDataLoaded = true;
      this.alertService.close();
    }).catch(() => {
      this.alertService.close();
    });
  }

  detectReference() {
    this.pageSize = Number(this.localStorageService.getItem('per_page'));
    this.sortColumn = String(this.localStorageService.getItem('sortColumn'));
    this.sortDirection = String(
      this.localStorageService.getItem('sortDirection')
    );

    this.route.queryParams.subscribe((params) => {
      if (params['tab']) {
        this.tab = params['tab'];
      }
    });

    this.getAccountTypeFromLocalStorage();

    const nuevaURL = this.location.path();
    const queryString = nuevaURL.includes('?') ? nuevaURL.substring(nuevaURL.indexOf('?')) : '';

    let paramReference = this.route.snapshot.paramMap.get('reference');

    for (const route in this.routesMap) {
      if (nuevaURL.includes(route)) {
        this.typeOrders = this.routesMap[route];
        this.stage_type = this.typeOrders;
        const nuevaRuta = `/campaigns/${this.typeOrders}${queryString}`;
        this.location.go(nuevaRuta);
        this.title = this.typeOrders == '' ? 'all' : this.typeOrders;

        break;
      }
    }

    if (paramReference === this.typeOrders) {
      paramReference = null;
    }
    if (paramReference) {
      this.campaign_reference = paramReference;
      const updatedURL = `/${this.typeOrders}/${paramReference}${queryString}`;
      this.location.go(updatedURL);
      // this.getCampaign(paramReference);
    }

    this.cargaladata.typeOrders = this.typeOrders;
  }

  onPageChange(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    this.localStorageService.setItem('per_page', String(event.pageSize));
    this.pageSize = event.pageSize;

    if (this.currentStep === 3) {
      this.alertService.loading('swal_messages.please_wait');
      this.fetchDataStock().then(() => {
        this.alertService.close();
      }).catch(() => {
        this.alertService.close();
      });
    } else {
      this.fetchNewData();
    }
  }

  toggleForm() {
    this.showForm = !this.showForm;
    this.isEditMode = false;
  }

  cerrarFormulario() {
    this.titleService.setTitle('Pedidos - DBM');

    this.campaignData = null;
    this.stockData = null;
    this.stockPreData = null;
    this.showForm = false;
    this.showFormOrders = false;
    this.showFormStock = false;
    this.campaign_reference = null;
    this.removeUrlCampaignParam();

    // If we were in expanded view, stay there and refresh
    if (this.isViewingExpanded) {
      this.currentStep = 5;
      this.fetchExpandedData();
    }
  }

  refrescar() {
    if (this.isViewingExpanded) {
      this.fetchExpandedData();
      return;
    }
    this.fetchData();
  }

  getBadgeColorRegistered(registered: string): string {
    const registeredColorMap: { [key: string]: string } = {
      '1': 'text-new',
      '0': 'text-used',
    };
    return registeredColorMap[registered] || 'text-new';
  }

  getAccountTypeFromLocalStorage(): void {
    this.accountType = this.authStateService.getAccountType();
  }

  refreshCampaignsData() {
    this.campaignsService
      .getCampaigns(
        this.pageNumber,
        this.pageSize,
        this.searchParams,
        this.sortColumn,
        this.sortDirection
      )

      .subscribe({
        next: (data) => {
          this.dataSource.data = data.data;
          this.dataSource.sort = this.sort;

          // Actualizar información de unidades y vehículo de la primera campaña
          if (data.data && data.data.length > 0) {
            const firstCampaign: any = data.data[0];
            ////
            this.campaignUnitsInfo = {
              virtual_available_units: firstCampaign.virtual_available_units || 0,
              available_units: firstCampaign.available_units || 0,
              units: firstCampaign.units || 0,
              name: firstCampaign.name || '',
              vehicle_brand: firstCampaign.vehicle_brand || '',
              vehicle_models: firstCampaign.vehicle_models || '',
              vehicle_model_year: firstCampaign.vehicle_model_year || '',
              vehicle: firstCampaign.vehicle || '',
              vehicle_status: firstCampaign.vehicle_status || '',
              colour: firstCampaign.colour || '',
              type: firstCampaign.type || '',
              supplier_name: firstCampaign.supplier_name || '',
              vendor_name: firstCampaign.vendor_name || '',
              vehicle_registered: this.vehicle_registered || 0,
              campaign_stock_warning_label: this.selectedStock?.campaign_stock_warning_label || null,
              breakdown: firstCampaign.breakdown || {
                total_units: firstCampaign.units || 0,
                signed_contracts: (firstCampaign.units || 0) - (firstCampaign.available_units || 0),
                estimated_in_risk: (firstCampaign.available_units || 0) - (firstCampaign.virtual_available_units || 0)
              }
            };
          }

          this.pageNumber = data.meta.current_page;
          if (!this.localStorageService.getItem('per_page')) {
            this.localStorageService.setItem('per_page', data.meta.per_page);
            this.pageSize = data.meta.per_page;
          } else {
            this.pageSize = Number(
              this.localStorageService.getItem('per_page')
            );
          }
          if (this.paginator) {
            this.paginator.pageSizeOptions = [25, 50, 100];
            this.paginator.pageSize = this.pageSize;
            this.paginator.pageIndex = this.pageNumber - 1;
            this.paginator.length = data.meta.total;
          }


        },
        error: (error) => {
          this.alertService.error(error.error);
        },
      });
  }


  getUnitsTooltip(data: any): string {
    const breakdown = data.breakdown;
    const total = breakdown?.total_units ?? (data.units || 0);
    const signed = breakdown?.signed_contracts ?? ((data.units || 0) - (data.available_units || 0));
    const risk = breakdown?.estimated_in_risk ?? ((data.available_units || 0) - (data.virtual_available_units || 0));
    const virtual = data.virtual_available_units || 0;
    const pad = 24;
    const t = (key: string) => this.translate.instant('inputs.' + key);
    return [
      t('totals').padEnd(pad) + total,
      t('signed_contracts').padEnd(pad) + '-' + signed,
      t('estimated_in_risk').padEnd(pad) + '-' + risk,
      '―'.repeat(pad + 4),
      t('availables').padEnd(pad) + virtual,
    ].join('\n');
  }

  getMinValue(data: any): number {
    const allValues = Object.values(data)
      .flatMap(inner => Object.values(inner as object));
    const minValue: any = Math.min(...allValues);
    return minValue;
  }



  onSortChange(event: Sort) {
    let column = this.sortMap[String(event.active)];
    if (column == 'actions') {
      if (this.sort) {
        this.sort.direction = '';
      }
    } else {
      this.pageNumber = 1;
      this.localStorageService.setItem('sortColumn', column);
      this.localStorageService.setItem(
        'sortDirection',
        String(event.direction)
      );
      this.sortColumn = event.active;
      this.sortDirection = event.direction == '' ? 'asc' : event.direction;
      this.fetchNewData();
    }

  }

  onSortChange2(event: string) {
    this.sortColumn = this.sortMap[String(event)];
    this.localStorageService.setItem('sortColumn', this.sortColumn);
    if (this.sortDirection == 'asc') {
      this.sortDirection = 'desc';
    } else {
      this.sortDirection = 'asc';
    }

    this.localStorageService.setItem('sortDirection', this.sortDirection);

    this.pageNumber = 1;

    if (this.currentStep === 3) {
      this.alertService.loading('swal_messages.please_wait');
      this.fetchDataStock().then(() => {
        this.alertService.close();
      }).catch(() => {
        this.alertService.close();
      });
    } else {
      this.fetchNewData();
    }
  }


  getDirection(): string {
    const directionMap: { [key: string]: string } = {
      asc: 'icon-arrow-up',
      desc: 'icon-arrow-down',
    };

    return directionMap[this.sortDirection] || 'icon-arrow-up';
  }



  handleClickDocument(url: string) {
    this.alertService.loading('swal_messages.please_wait_documents');
    const a = document.createElement('a');
    a.href = url;
    a.click();
    setTimeout(() => {
      this.alertService.close();
    }, 1000);
  }

  filterChanged(searchTerm: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.alertService.loading('swal_messages.please_wait');
      this.searchParams = searchTerm;

      // Expanded view: use expanded endpoint
      if (this.currentStep === 5 && this.isViewingExpanded) {
        this.expandedSearchParams = searchTerm;
        this.expandedPageNumber = 1;
        this.campaignsService.getCampaignsExpanded(
          this.expandedPageNumber,
          this.expandedPageSize,
          searchTerm,
          this.expandedSortColumn,
          this.expandedSortDirection,
          this.typeOrders || 'enabled'
        ).subscribe({
          next: (data: any) => {
            this.dataSource.data = data.data || [];
            if (this.paginator && data.meta) {
              this.paginator.length = data.meta.total;
              this.paginator.pageSize = this.expandedPageSize;
              this.paginator.pageIndex = 0;
            }
            this.alertService.close();
            resolve();
          },
          error: (error: any) => {
            this.alertService.close();
            reject(error);
          },
        });
        return;
      }

      if (this.currentStep === 3) {
        this.stocksService
          .getStocksStage(
            this.pageNumber,
            this.pageSize,
            searchTerm,
            this.sortColumn,
            this.sortDirection,
            this.typeOrders
          )
          .subscribe({
            next: (data) => {
              this.dataSourceStocks.data = data.data;
              this.dataSourceStocks.sort = this.sort;
              this.pageNumber = data.meta.current_page;

              if (this.paginator) {
                this.paginator.pageSize = this.pageSize;
                this.paginator.pageIndex = this.pageNumber - 1;
                this.paginator.length = data.meta.total;
              }
              this.alertService.close();
              resolve();
            },
            error: (error) => {
              this.alertService.error(error.error);
              reject(error);
            },
          });
      } else {
        this.campaignsService
          .getCampaignsStage(
            this.pageNumber,
            this.pageSize,
            searchTerm,
            this.sortColumn,
            this.sortDirection,
            this.typeOrders
          )
          .subscribe({
            next: (data) => {
              this.dataSource.data = data.data;
              this.cargaladata.flag = true;
              this.dataSource.sort = this.sort;

              // Actualizar información de unidades y vehículo de la primera campaña
              if (data.data && data.data.length > 0) {
                const firstCampaign: any = data.data[0];
                this.campaignUnitsInfo = {
                  virtual_available_units: firstCampaign.virtual_available_units || 0,
                  available_units: firstCampaign.available_units || 0,
                  units: firstCampaign.units || 0,
                  name: firstCampaign.name || '',
                  vehicle_brand: firstCampaign.vehicle_brand || '',
                  vehicle_models: firstCampaign.vehicle_models || '',
                  vehicle_model_year: firstCampaign.vehicle_model_year || '',
                  vehicle: firstCampaign.vehicle || '',
                  vehicle_status: firstCampaign.vehicle_status || '',
                  colour: firstCampaign.colour || '',
                  type: firstCampaign.type || '',
                  supplier_name: firstCampaign.supplier_name || '',
                  vendor_name: firstCampaign.vendor_name || '',
                  campaign_stock_vehicle_registered: firstCampaign.campaign_stock_vehicle_registered,
                  campaign_stock_warning_label: this.selectedStock?.campaign_stock_warning_label || null,
                  breakdown: firstCampaign.breakdown || {
                    total_units: firstCampaign.units || 0,
                    signed_contracts: (firstCampaign.units || 0) - (firstCampaign.available_units || 0),
                    estimated_in_risk: (firstCampaign.available_units || 0) - (firstCampaign.virtual_available_units || 0)
                  }
                };
              }

              this.pageNumber = data.meta.current_page;
              if (!this.localStorageService.getItem('per_page')) {
                this.localStorageService.setItem('per_page', data.meta.per_page);
                this.pageSize = data.meta.per_page;
              } else {
                this.pageSize = Number(
                  this.localStorageService.getItem('per_page')
                );
              }
              if (this.paginator) {
                this.paginator.pageSizeOptions = [25, 50, 100];
                this.paginator.pageSize = this.pageSize;
                this.paginator.pageIndex = this.pageNumber - 1;
                this.paginator.length = data.meta.total;
              }
              this.alertService.close();
              resolve();
            },
            error: (error) => {
              this.alertService.error(error.error);
              reject(error);
            },
          });
      }
    });
  }

  showDocumentsPopup(row: any): void {
    const documents: any[] = row.documents || [];
    const campaignName = row.name || row.campaign_reference || '';

    if (documents.length === 0) {
      Swal.fire({
        title: this.translate.instant('tooltip.viewDocuments'),
        text: this.translate.instant('tooltip.noDocuments'),
        icon: 'info',
        confirmButtonColor: 'var(--color-primary-300, #556ee6)',
      });
      return;
    }

    const listHtml = documents.map((doc: any) => {
      const typeName = this.translate.instant('select.document_type.' + doc.type) || doc.type;
      const fileName = doc.name || 'document';
      const typeColor = this.pickADocColor(doc.type);
      const thumbnailSrc = this.getDocThumbnail(fileName);
      const createdBy = doc.created_by || '';
      const createdAt = doc.created_at || '';
      const eyeLabel = this.translate.instant('buttons.eye');
      const downloadLabel = this.translate.instant('forms.buttons.download');

      return `
        <div class="form-section-documents" style="display:flex;align-items:center;padding:8px 0;border-bottom:1px solid var(--color-gray-100, #f0f0f0);">
          <a href="${doc.file}" download="${fileName}" target="_blank" style="flex:1;min-width:0;text-decoration:none;color:inherit;">
            <li class="existDocument" style="list-style:none;display:flex;align-items:center;margin:0;">
              <img class="thumbnail" src="${thumbnailSrc}" alt="Thumbnail" style="width:30px;height:30px;margin-right:5px;" />
              <i class="icon-download2"></i>
              <div class="type" style="background-color:${typeColor};border-radius:5px;display:inline-block;margin:0 5px;padding:3px 5px;font-size:12px;">${typeName}</div>
              <span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="${fileName}">${fileName}</span>
              <span class="secondary-text" style="color:var(--color-gray-400, #adb5bd);font-size:11px;margin-left:4px;white-space:nowrap;">(${createdAt})</span>
            </li>
          </a>
          <span class="clickable ms-1" style="cursor:pointer;margin-left:8px;white-space:nowrap;"
            onclick="window.open('${doc.file}', '_blank')">
            <i class="icon-eye"></i> <span>${eyeLabel}</span>
          </span>
        </div>`;
    }).join('');

    Swal.fire({
      title: this.translate.instant('tooltip.viewDocuments'),
      html: `
        <div style="color:var(--color-gray-500, #6c757d);margin-bottom:12px;font-size:13px;">${campaignName}</div>
        <ul style="list-style:none;padding:0;text-align:left;max-height:400px;overflow-y:auto;">
          ${listHtml}
        </ul>`,
      showCloseButton: true,
      showConfirmButton: false,
      width: '700px',
    });
  }

  private getDocThumbnail(name: string): string {
    const patterns: Record<string, RegExp> = {
      jpg: /\.(jpg|jpeg|png)$/i,
      pdf: /\.pdf$/i,
      doc: /\.(docx?|dotx?)$/i,
      xls: /\.(xls?|xlsx?)$/i,
      zip: /\.zip$/i,
    };
    for (const [key, pattern] of Object.entries(patterns)) {
      if (pattern.test(name)) {
        return `assets/icons/${key}.svg`;
      }
    }
    return 'assets/icons/file.svg';
  }

  private pickADocColor(type: string): string {
    const colorMap: Record<string, string> = {
      'equipment': '#a7cce0',
      'manufacturer_quote': '#f0ab96',
      'car_details': '#9daff0',
      'other': '#d0e5e8',
    };
    return colorMap[type] || '#d0e5e8';
  }
}
